import * as React from 'react';
import { SIDE_NAV_ID } from './side-nav-constants';
import type { ISideNavMobileToggleProps } from './types';
import { cn } from '@utils';

/**
 * Floating hamburger control shown when the mobile side nav is closed.
 */
export const SideNavMobileToggle: React.FC<ISideNavMobileToggleProps> = ({
	onClick,
	expanded = false,
	controlsId = SIDE_NAV_ID,
	'aria-label': ariaLabel,
	icon,
	className,
}) => {
	return (
		<button
			type="button"
			onClick={onClick}
			aria-label={ariaLabel}
			aria-expanded={expanded}
			aria-controls={controlsId}
			data-testid="side-nav-mobile-toggle"
			className={cn(
				'fixed top-[1.6rem] left-[1.6rem] z-[100] flex h-[4rem] w-[4rem] items-center justify-center',
				'rounded-[1rem] border border-white/20 bg-primary/90 text-white shadow-lg backdrop-blur-sm',
				'transition-colors hover:bg-primary focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-accent',
				className
			)}
		>
			{icon}
		</button>
	);
};

SideNavMobileToggle.displayName = 'SideNavMobileToggle';
